import { render, staticRenderFns } from "./SourceMissionFamilyCard.vue?vue&type=template&id=252d8773&scoped=true"
import script from "./SourceMissionFamilyCard.vue?vue&type=script&lang=js"
export * from "./SourceMissionFamilyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252d8773",
  null
  
)

export default component.exports